import { inject, Injectable } from '@angular/core';
import { map, of } from 'rxjs';
import { ListSearch } from '@fry/lib/list';
import { RolesStore } from '@fry/lib/roles';


@Injectable()
export class DashboardsSearch implements ListSearch {

  private roles = inject(RolesStore);

  constructor() {}

  public filters() {
    return this.roles.allWithSystem().pipe(
      map(roles => {
        return [
          {
            id: 'roles',
            label: $localize `Show only templates for these roles`,
            widget: {
              type: 'multiSelect'
            },
            filter: (item, value) => {
              const roles = item.doc.roles || [];
              const res = value.some((role: string) => roles.includes(role));
              return of(res);
            },
            options: {
              categories: roles.map(role => {
                return { id: role.doc._id, name: role.doc.title };
              })
            }
          },
          {
            id: 'usedFor',
            label: '',
            filter: (item, value) => {
              return of((item.doc.usedFor || []).includes(value));
            },
            featured: false,
            widget: {
              type: 'hidden',
              placeholder: $localize `Used for`,
            },
            options: {
              categories: [
                { id: 'dashboard', name: $localize `Dashboard` },
                { id: 'summary', name: $localize `Summary` },
              ]
            }
          }
        ];
      })
    );
  }

  public sorts() {
    return of([
      {
        id: 'name',
        name: $localize `Name`,
      }
    ]);
  }

}
